import { Link } from 'react-router-dom'
import Seo from '../components/Seo.jsx'
import Related from '../components/Related.jsx'
import { ARTICLES, formatDate } from '../lib/articles.js'

/*
 * Article index (/articles). Lists every LIVE article newest-first. Scheduled and
 * draft articles are excluded by src/lib/articles.js, so this only ever shows what
 * has actually been published.
 */
export default function Articles() {
  return (
    <main className="page">
      <Seo
        title="Peptide & GLP-1 Articles | CalculateMyPeptides"
        description="In-depth, plain-language articles on peptides and GLP-1 medications — dosing, reconstitution, side effects, and how to use them safely. Educational, not medical advice."
        image="/og/guide.png"
        breadcrumbs={[{ name: 'Home', path: '/' }, { name: 'Articles', path: '/articles' }]}
      />
      <div className="container">
        <div style={{ marginBottom: 22 }}>
          <span className="pill blue" style={{ marginBottom: 8 }}>Articles</span>
          <h1 className="section-title">Peptide &amp; GLP-1 Articles</h1>
          <p className="section-sub" style={{ maxWidth: '62ch' }}>
            Practical, well-sourced explainers on peptides and GLP-1 medications — the dosing math, the science, and
            the questions people actually search for. Educational only, not medical advice.
          </p>
        </div>

        {ARTICLES.length === 0 ? (
          <div className="card empty">
            <div className="emoji">📝</div>
            <h3 style={{ marginBottom: 6 }}>No articles yet</h3>
            <p style={{ marginBottom: 0 }}>New explainers are on the way — check back soon.</p>
          </div>
        ) : (
          <div className="article-grid">
            {ARTICLES.map((a) => (
              <Link key={a.slug} to={`/articles/${a.slug}`} className="card article-card fade-in">
                <div className="article-card-body">
                  <div className="article-meta">
                    <span>{formatDate(a.date)}</span>
                    <span aria-hidden>·</span>
                    <span>{a.readingMins} min read</span>
                  </div>
                  <h2 className="article-card-title">{a.title}</h2>
                  <p className="article-card-desc">{a.description}</p>
                </div>
                <div className="article-card-foot">
                  {a.tags.slice(0, 3).map((t) => <span key={t} className="pep-tag">{t}</span>)}
                  <span className="pep-arrow" style={{ marginLeft: 'auto' }}>Read →</span>
                </div>
              </Link>
            ))}
          </div>
        )}

        <Related
          title="Also useful"
          links={[
            { to: '/calculator', label: 'Peptide calculator', desc: 'Run your own numbers' },
            { to: '/guides', label: 'Guides', desc: 'Reconstitution & dosing' },
            { to: '/peptides', label: 'Peptide library', desc: 'Per-compound profiles' },
            { to: '/glossary', label: 'Glossary', desc: 'Every term defined' },
          ]}
        />
      </div>
    </main>
  )
}
